<div class="item">
  <div class="item-key text-color--tertiary font-body-3">{{ key }}:</div>
  <ng-content></ng-content>
</div>
